import React from "react";

import RCSlider from "rc-slider";
import "rc-slider/assets/index.css";

import { editor_primary_color } from "../../../utils/Utilities";

interface SliderProps {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
}

function Slider({
  value,
  min = 1,
  max = 10,
  step = 1,
  onChange,
}: SliderProps): React.ReactElement {
  const createSliderMarks = (): Record<number, string> => {
    const marks: Record<number, string> = {};
    for (let i = min; i <= max; i += step) {
      marks[i] = i.toString();
    }
    return marks;
  };

  return (
    <RCSlider
      dots
      defaultValue={value || 6}
      marks={createSliderMarks()}
      max={max}
      min={min}
      onChange={onChange}
      railStyle={{ backgroundColor: "var(--surface-muted)", height: 8 }}
      step={step}
      activeDotStyle={{
        borderColor: editor_primary_color,
        bottom: -6,
        width: 12,
        height: 12,
        marginLeft: -6,
      }}
      dotStyle={{
        bottom: -6,
        width: 12,
        height: 12,
        marginLeft: -6,
      }}
      handleStyle={{
        borderColor: editor_primary_color,
        height: 20,
        width: 20,
        marginLeft: 0,
        marginTop: -6,
      }}
      trackStyle={{
        backgroundColor: editor_primary_color,
        height: 8,
      }}
    />
  );
}

export default Slider;
